// components/onboarding/OnboardingFooter.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const OnboardingFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} Wayuvega. All rights reserved.
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link
              to="/terms-and-conditions"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/privacy-policy"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to="/refund-policy"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              Refund Policy
            </Link>
            <a
              href="mailto:support@wayuvega.in"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              Contact Support
            </a>
          </div>
        </div>

        {/* Secure Badge */}
        <div className="flex justify-center mt-6">
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <svg
              className="w-4 h-4 text-green-600"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944zM11 14a1 1 0 11-2 0 1 1 0 012 0zm0-7a1 1 0 10-2 0v3a1 1 0 102 0V7z"
                clipRule="evenodd"
              />
            </svg>
            <span>Your data is encrypted and secure</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default OnboardingFooter;



